export class ModelDataUpdate<T> {
  public data: T;

  constructor(data: T) {
    this.data = data;
  }
}
